import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import ThreeItems from './ThreeItems';
import { styles } from './styles/videoCollectionStyles';
import {parseImagesTag} from '../../shared/utils';
import VideoCollectionsService from '../VideoCollectionsService';

class VideoShowCollection extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			collection: props.collection,
		};
	}

	render() {
		const collection = this.state.collection;
        const ContainerTag = ThreeItems;
        let logoImgTag = parseImagesTag(collection.logoImage)
        let bgImgTag = parseImagesTag(collection.bgImage)
        let utmObj = VideoCollectionsService.setCollectionUTM(collection, this.props.index);

		return (
			<div id={this.props.id} className={css(styles.collectionWrapper)}>
				<div className={css(styles.showContainer)}>
                    <input type="hidden" value={collection.posts.length} className={'collection-size_vc'}/>
                    <div className={css(styles.showImageCont)}>
                        <div className={css(styles.imageWrapper)}>
                            <div className={css(styles.showOverlay)}></div>
                            <img className={css(styles.showImage) + ' lazyload'} data-src={bgImgTag.src} data-srcset={bgImgTag.srcSet} data-sizes={bgImgTag.sizes}  />
                            {bgImgTag.noscript &&
							    <noscript>{bgImgTag.noscript}</noscript>
						    }
                        </div>
                    </div>
                    <div className={css(styles.showVCContainer)}>
                        <div className={css(styles.showDetails)}>
                            <div className={css(styles.showLogo)}>
                                <a href={collection.moreLink} className={css(styles.logoLink)}>
                                    <img className={css(styles.showLogoImg) + ' lazyload'} data-src={logoImgTag.src} data-srcset={logoImgTag.srcSet} data-sizes={logoImgTag.sizes}/>
                                    {logoImgTag.noscript &&
                                        <noscript>{logoImgTag.noscript}</noscript>
                                    }
                                </a>
                            </div>
                            <span className={css(styles.airTime)}> {collection.airTime} </span>
                            <a href={collection.moreLink} className={css(styles.moreBtnBg)}>
                                <label className={css(styles.moreBtnText)}> {collection.moreLabel} </label>
                            </a>
                            <span className={css(styles.divider)}></span>
                        </div>
                        <div className={css(styles.vcWrapper)}>
                            <ContainerTag posts={collection.posts} show={ true } containerStyle={styles.containerVC} utmObj={utmObj} />
                        </div>
                    </div>
                </div>
            </div>
		);
	}
}

export default VideoShowCollection;



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/VideoShowCollection.js